import React, { useState, useEffect, useContext} from "react"
import { useNavigate, useParams } from 'react-router-dom';

import {
  Box,
  Container,
  Button,
  Hidden,
} from '@material-ui/core';

const PageContentWrapper = ( {withoutHeader, withScanReturn, title, title2, buttonTitle, buttonIcon, buttonOnClick, buttonDisabled, onglets, children} ) => {
  const navigate = useNavigate();

  let { id } = useParams();

  return (
    <>
      <Box sx={{ borderBottom:"1px solid #E7E7E7", display: withoutHeader === true ? "none" : "block"}}>
        <Container maxWidth="100%">
          <Box sx={{py:3, display:"flex", alignItems:"center", justifyContent:"space-between", flexShrink:0, gap:"10px"}}>
            {(withScanReturn === true && title) ? (
              <Box sx={{display:"flex"}}>
                <Box sx={{
                  fontSize:["26px", "36px", "46px"],
                  fontWeight:"700",
                  textTransform:"capitalize",
                  wordBreak:"break-word",
                  color:"text.primary",
                  userSelect:"none",
                }}>
                  <span
                    style={{
                      cursor:"pointer",
                    }}
                    onClick={() => {
                      navigate("/app/scan/"+id)
                    }}
                  >
                    {`${title} / `}
                  </span>
                  <span style={{
                    color:"black",
                  }}>{title2 || ""}</span>
                </Box>

              </Box>
            ) : (
              <Box sx={{
                fontSize:["26px", "36px", "46px"],
                fontWeight:"700",
                textTransform:"capitalize",
                wordBreak:"break-word",
              }}>
                {title}
              </Box>
            )}
            {buttonTitle &&
              <Box>
                <Hidden smDown>
                  <Button
                    variant="contained"
                    size={"medium"}
                    endIcon={buttonIcon ? buttonIcon : null}
                    onClick={buttonOnClick ? buttonOnClick : null}
                    disabled={buttonDisabled}
                  >
                    {buttonTitle}
                  </Button>
                </Hidden>
                <Hidden smUp>
                  <Button
                    variant="contained"
                    size={"small"}
                    endIcon={buttonIcon ? buttonIcon : null}
                    onClick={buttonOnClick ? buttonOnClick : null}
                    disabled={buttonDisabled}
                  >
                    {buttonTitle}
                  </Button>
                </Hidden>
              </Box>
            }
          </Box>
          {(onglets && onglets.length > 0) &&
            <Box sx={{display:"flex", gap:2, pt:1}}>
              {onglets.map((item, index) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      display:"flex",
                      alignItems:"center",
                      gap:"6px",
                      fontSize:["15px", "16px", "18px"],
                      fontWeight:700,
                      pl : 2,
                      pr : 2,
                      pb : 1,
                      borderBottom:"1px solid black",
                      cursor:"pointer",
                      userSelect:"none",
                      "&:hover" : {
                        borderBottom:"1px solid #565656",
                        color:"#565656"
                      }
                    }}
                    onClick={item?.onClick ? item.onClick : null}
                  >
                    {item?.icon && item?.icon}
                    {item?.title}
                  </Box>
                )
              })}
            </Box>
          }
        </Container>
      </Box>
      <Box sx={{backgroundColor:"background.default", py:[3, 4, 5], flexGrow:1, display:"flex"}}>
        <Container maxWidth="100%" sx={{display:"flex", flexGrow:1}}>
          {children}
        </Container>
      </Box>
    </>
  );
};

export default PageContentWrapper;
